/*
 * ॐ नमः शिवाय
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms 
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this 
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and 
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

import React from 'react';
import { useTheme } from '../theme/ThemeContext';

const GaneshaLogo = ({ width = 40, height = 40, className, style, color = '#ffffff' }) => {
    const { theme } = useTheme();

    // Use passed color or default to white
    const strokeColor = color;

    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 100 100"
            className={className}
            style={style}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            stroke={strokeColor}
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            {/* 
        Design v3: Kawaii Tech Ganesha
        - Ultra-cute round head
        - Huge eyes
        - Blush marks
        - Tech nodes for the "cyber" feel
      */}

            {/* Head - A soft, wide squircle for maximum cuteness */}
            <path d="M20,40 Q20,15 50,15 Q80,15 80,40 L80,60 Q80,85 50,85 Q40,85 30,92" />

            {/* Tiny Trunk Curl - Cute and small */}
            <path d="M30,92 Q35,97 42,92" />

            {/* Ears - Very rounded, set slightly lower for 'baby' look */}
            <path d="M20,40 Q5,40 5,60 Q5,75 25,65" />
            <path d="M80,40 Q95,40 95,60 Q95,75 75,65" />

            {/* Eyes - Huge and wide set (Kawaii Style) */}
            {/* Left Eye */}
            <ellipse cx="32" cy="50" rx="6" ry="8" strokeWidth="3" />
            {/* Right Eye */}
            <ellipse cx="68" cy="50" rx="6" ry="8" strokeWidth="3" />

            {/* Blush Marks (Cheeks) - The essence of cute */}
            <path d="M18,60 L24,62" strokeWidth="2.5" opacity="0.8" />
            <path d="M18,64 L24,66" strokeWidth="2.5" opacity="0.8" />

            <path d="M76,60 L82,62" strokeWidth="2.5" opacity="0.8" />
            <path d="M76,64 L82,66" strokeWidth="2.5" opacity="0.8" />

            {/* Tech Nodes (Dots) - Keeping the cyber DNA */}
            <circle cx="20" cy="40" r="3" fill={strokeColor} stroke="none" />
            <circle cx="80" cy="40" r="3" fill={strokeColor} stroke="none" />
            <circle cx="50" cy="15" r="3" fill={strokeColor} stroke="none" />

            {/* Bindi - Soft Diamond / Tech Node */}
            <rect x="47" y="25" width="6" height="6" transform="rotate(45 50 28)" fill={strokeColor} stroke="none" />

            {/* Simple Head Detail (Cyber Crown) */}
            <path d="M40,15 L40,10" strokeWidth="3" />
            <path d="M60,15 L60,10" strokeWidth="3" />
            <circle cx="40" cy="8" r="2" fill={strokeColor} stroke="none" />
            <circle cx="60" cy="8" r="2" fill={strokeColor} stroke="none" />

        </svg>
    );
};

export default GaneshaLogo;
